// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"28cfac17","331":"e1204b44","441":"dae8b7f8","524":"c213d171","600":"58191ce6","635":"dae8b7f8","695":"dae8b7f8","700":"dae8b7f8","918":"58191ce6"}[chunkId] + ".chunk.css";
};